
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/touristroutes/[id]/[slug]",
      function () {
        return require("private-next-pages/touristroutes/[id]/[slug].tsx");
      }
    ]);
  